module.exports = __webpack_public_path__ + "static/media/map-image1.d9a0574b.jpg";